import { checkUserPermission } from '../../utils/CheckUserPermitions';

export const MANAGE_BRANCH_GROUPS = 'manage_branch_groups';
const SUPER_ADMIN_ROLE_ID = 1;
export const BRANCH_LIMITED_ROLE_NAME = 'Admin Sucursal';

/* Usuario limitado a sus sucursales asignadas. Puede administrar grupos (si su rol tiene el permiso), pero solo con las
   sucursales que tiene asignadas y solo los grupos que creó; el servidor lo impone en cada petición. */
export const isBranchLimitedUser = (user) => (Array.isArray(user?.role) ? user.role : [])
  .some((role) => role.name === BRANCH_LIMITED_ROLE_NAME)
  && !(Array.isArray(user?.role) ? user.role : []).some((role) => Number(role.role_id) === SUPER_ADMIN_ROLE_ID);

/* Decide si se muestran las acciones de administración de grupos: hace falta el permiso de rol manage_branch_groups
   (también para los usuarios limitados a sucursales).
   Solo oculta o muestra: el servidor vuelve a validar el permiso de rol, el tipo de token y las sucursales del usuario
   en cada petición, así que alterar esto en el navegador no concede nada. */
export const canManageBranchGroups = (user) => {
  if (!user) return false;
  const roles = Array.isArray(user.role) ? user.role : [];

  // El servidor no aplica el permiso de rol al super administrador
  if (roles.some((role) => Number(role.role_id) === SUPER_ADMIN_ROLE_ID)) return true;
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];
  return checkUserPermission(MANAGE_BRANCH_GROUPS, permissions) !== -1;
};
